function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5538 1.16732C15.9296 1.41727 16.0914 1.88802 15.9487 2.31623L13.6902 9.09163L17.5547 11.668C17.8143 11.841 17.9782 12.1252 17.998 12.4365C18.0178 12.7478 17.8912 13.0505 17.6557 13.255L8.1557 21.505C7.81542 21.8005 7.31952 21.8319 6.94471 21.5817C6.5699 21.3314 6.40881 20.8613 6.55133 20.4338L8.77707 13.7566L4.5528 11.6444C4.25477 11.4954 4.05054 11.2078 4.00814 10.8773C3.96574 10.5468 4.09074 10.2168 4.34151 9.99743L14.3415 1.24743C14.6812 0.950196 15.1779 0.917373 15.5538 1.16732ZM6.7795 10.5217L10.4472 12.3556C10.8923 12.5781 11.1061 13.0941 10.9487 13.5662L9.60489 17.5976L15.3543 12.6047L11.9453 10.3321C11.5701 10.0819 11.4087 9.61159 11.5513 9.18378L12.8866 5.17803L6.7795 10.5217Z"
});

var SvgStepTypeTrigger = function SvgStepTypeTrigger(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22",
      fill: "none"
    }, props), _ref)
  );
};

export default SvgStepTypeTrigger;